import {ApiError} from '@pocketbuy/outdoor-api-client';

export function pickupRequestError(error:unknown):string {
 if(error instanceof ApiError){
  if(error.code==='PICKUP_OVERDUE_PHONES')return error.message;
  if(error.status===401)return 'Your session expired. Sign in again, then review your pickup requests before submitting again.';
  if(['INVALID_REQUEST','STATE_CONFLICT','FORBIDDEN'].includes(error.code)&&(!error.status||error.status<500)){
   const message=error.message;
   if(message.startsWith('Phone limit reached:'))return message;
   if(/cluster|stock point|stockPointId/i.test(message))return 'Your cluster’s pickup stock point is not available for this request. Contact your Business Manager or Business Executive to check your cluster and stock point, then try again.';
   if(/SKU|model/i.test(message))return 'A selected phone model is no longer available to request. Go back and choose another model.';
   if(/workspace|authorized|permission/i.test(message))return 'This account cannot submit a pickup request. Switch to your Sales Agent role or contact your administrator.';
   if(/quantity|At least one phone/i.test(message))return 'Select at least one phone and check each quantity before submitting.';
  }
 }
 return 'We could not confirm whether your request was submitted. Your selected phones are kept. Check Pickup requests before trying again to avoid a duplicate request.';
}
